import Button from "./Button";
import { useFormikContext } from "formik";
import { type ComponentProps } from "react";
import { useUploadLock } from "./useUploadLock";

type FormikSubmitButtonProps = ComponentProps<typeof Button>;

export default function FormikSubmitButton({
  children,
  ...props
}: FormikSubmitButtonProps) {
  const { isSubmitting } = useFormikContext();
  // Un fichier encore en cours d'envoi n'est pas dans le formulaire : soumettre
  // maintenant le perdrait.
  const uploading = useUploadLock().pending > 0;
  return (
    <Button
      {...props}
      type="submit"
      disabled={isSubmitting || uploading || props.disabled}
      isLoading={isSubmitting || uploading || props.isLoading}
    >
      {children}
    </Button>
  );
}
